// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Type definitions for different unit measurements.
 * @author James Reid
 */

// @ts-check

// @@no-imports

// @@body
/**
 * Metric measurement decimal number (numbers in any measurement context are
 * globally assumed to be decimal metric measurements).
 * @typedef {number} MetricMeasurement
 */

/**
 * Imperial measurement object containing feet and inches fields.
 * @typedef {object} ImperialMeasurement
 * @property {number} [feet] Number of feet in measurement (should be int).
 * @property {number} [inches] Number of inches in measurement (ideally should
 * be integer, although could be decimal).
 */

// @@exports
/**
 * @type {MetricMeasurement}
 * @ignore
 */
export let MetricMeasurement

/**
 * @type {ImperialMeasurement}
 * @ignore
 */
export let ImperialMeasurement
